const translations = {
  sv: {
    address: 'Adress',
    contact: 'Kontakt'
  },
  en: {
    address: 'Address',
    contact: 'Contact'
  },
  no: {
    address: 'Adresse',
    contact: 'Kontakt'
  },
  da: {
    address: 'Adresse',
    contact: 'Kontakt'
  }
};

export function footer() {
  copyLogoToFooter();
  separateCompanyInformation();
}

function copyLogoToFooter() {
  const footerLogo = `<img src="/images/site/entrade.svg" alt="Logo" class="footer-logo" />`;
  const footerInner = $('#MainFooter_FooterInner');

  if (!footerInner.length) {
    console.warn('#MainFooter_FooterInner not found');
    return;
  }

  if (footerInner.find('.footer-logo').length) {
    return; // Logo already exists
  }

  footerInner.prepend(footerLogo);
}

function separateCompanyInformation() {
  const companyInfo = $('#MainFooter_CompanyInformation');

  if (!companyInfo.length) {
    console.warn('#MainFooter_CompanyInformation not found');
    return;
  }

  const lang = $('html').attr('lang') || 'sv';
  const texts = translations[lang] || translations.sv;

  const companyName = companyInfo.find('.companyName').detach();
  const companyEmail = companyInfo.find('.companyEmail').detach();
  const companyPhone = companyInfo.find('.companyPhoneNo').detach();
  const companyAddress = companyInfo.find('.companyAddress').detach();
  const companyVAT = companyInfo.find('.companyVAT').detach();

  // Reformat address: remove label and restructure
  if (companyAddress.length) {
    const addressValue = companyAddress.find('.value');
    const addressText = addressValue.html();

    // Split by <br> to separate street from zip/city
    const parts = addressText.split('<br>');
    if (parts.length >= 2) {
      // Remove label and format as: street on first line, zip + city on second line
      const newAddressHTML = `${parts[0].trim()}<br>${parts.slice(1).join(' ').trim()}`;
      addressValue.html(newAddressHTML);
    }

    // Remove the label
    companyAddress.find('.label').remove();
  }

  const addressWrapper = $('<div class="footer-address-wrapper"></div>');
  const addressTitle = $(`<h4 class="footer-section-title">${texts.address}</h4>`);
  const contactWrapper = $('<div class="footer-contact-wrapper"></div>');
  const contactTitle = $(`<h4 class="footer-section-title">${texts.contact}</h4>`);

  addressWrapper.append(addressTitle);
  addressWrapper.append(companyAddress);
  addressWrapper.append(companyVAT);

  contactWrapper.append(contactTitle);
  // contactWrapper.append(companyName);
  contactWrapper.append(companyEmail);
  contactWrapper.append(companyPhone);

  if (!companyInfo.find('.footer-address-wrapper').length) {
    companyInfo.append(addressWrapper);
  }

  if (!$('#MainFooter_FooterInner').find('.footer-contact-wrapper').length) {
    $('#MainFooter_FooterInner').append(contactWrapper);
  }
}
